import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Nao foi possivel enviar.");
    }
    setLoading(false);
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-navy">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-xl p-8" data-testid="forgot-form">
        <div className="text-blue uppercase text-xs font-semibold tracking-[0.2em] mb-2">Recuperacao</div>
        <h1 className="text-navy text-2xl font-bold tracking-tight mb-6">Esqueci-me da password</h1>
        {sent ? (
          <div className="text-emerald-700 bg-emerald-50 rounded-lg p-4 text-sm" data-testid="forgot-sent">
            Se a conta existir, foi enviado um link de redefinicao para o email indicado.
          </div>
        ) : (
          <>
            {error && <div className="mb-4 px-4 py-3 rounded-lg bg-red-50 text-red-600 text-sm" data-testid="forgot-error">{error}</div>}
            <label className="block text-sm font-semibold text-navy mb-1">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              data-testid="forgot-email"
              className="w-full mb-4 px-4 py-2.5 border border-tint rounded-lg" />
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full bg-blue text-white py-2.5 rounded-lg font-semibold disabled:opacity-50">
              {loading ? "A enviar..." : "Enviar link"}
            </button>
          </>
        )}
        <div className="mt-4 text-center">
          <Link to="/login" data-testid="forgot-back" className="text-sm text-blue">Voltar ao login</Link>
        </div>
      </form>
    </div>
  );
}
